export default __webpack_public_path__ + "static/N0302-8cbf045095c28d684e3b54575ca23c6c.png";